<form #form="ngForm">
<div id="content" class="nosidebarpage">
  <h1 anessaTranslation="PROJECT.INITIAL.PROJ_INPUT"></h1>
  <div *ngIf="showPage" class="selector-group" style="width: 100%;">
    <div
      (mouseenter)="showClearTitle = true && !isInitialFormUser"
      (mouseleave)="showClearTitle = false"
      style="margin: 20px;"
      class="border-outline form-field-container title-container">
      <div style="height: 0;">
        <h3 class="outline-border-header">{{'PROJECT.INITIAL.PROJECT_NAME' | anessaTranslation: trigger}}</h3>
      </div>
      <mat-form-field floatLabel="never">
        <mat-label>{{'PROJECT.INITIAL.ENTER_PROJECT_NAME' | anessaTranslation: trigger}}</mat-label>
        <input
          matInput
          required
          [disabled]="isInitialFormUser"
          [(ngModel)]="projectInfo.title"
          name="title"
          (ngModelChange)="changesMade()">
      </mat-form-field>
      <p
        *ngIf="projectInfo.title && showClearTitle"
        class="form-field-clear"
        (click)="clearInput('title')"
        anessaTranslation="PROJECT.COMMON.CLEAR">
      </p>
    </div>
    <div *ngIf="!isInitialFormUser" class="border-outline title-container">
      <div style="height: 10px;">
        <h3 class="outline-border-header">{{'PROJECT.INITIAL.COLLAB' | anessaTranslation: trigger}}</h3>
      </div>
      <anessa-table
        [data]="projectInfo.members"
        [keys]="['name', 'title','email']"
        [noTableItemsText]="('PROJECT.INITIAL.NO_COLLAB' | anessaTranslation: trigger)"
        [removeTooltipText]="('PROJECT.INITIAL.REMOVE_MEMBER' | anessaTranslation: trigger)"
        [cellstyle]="'lr|l'"
        (onEdit)="onEditMember($event)"
        (onRemove)="onDeleteMember($event)">
      </anessa-table>
      <button
        mat-button
        type="button"
        style="margin-top: 10px;"
        (click)="onAddMember()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div class="loadbar-expandable"></div>
  </div>

  <div class="input-list-container" *ngIf="showPage && hasChecklistAccess">
    <div class="input-list-option-buttons" *ngIf="!isInitialFormUser">
      <h2 anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.INPUT_LIST"></h2>
      <div>
        <button
          mat-button
          class="list-add-button button-width"
          [disabled]="creatingNewTemplate"
          type="button"
          (click)="useSavedTemplate()"
          anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.TEMPLATE.USE_SAVED_TEMPLATE">
        </button>
        <button
          mat-button
          class="list-add-button button-width"
          type="button"
          (click)="createNewTemplate()"
          anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.TEMPLATE.CREATE_NEW_TEMPLATE">
        </button>
      </div>
    </div>

    <div id="initial-form-checklist-form" *ngIf="projectInfo.checklists?.length > 0 && !creatingNewTemplate">
      <app-project-info-checklist-form [(checklists)]="projectInfo.checklists"></app-project-info-checklist-form>
    </div>

    <div id="initial-form-input-lists" *ngIf="creatingNewTemplate">
      <router-outlet></router-outlet>
    </div>

  </div>

  <div class="loadbar-expandable"></div>
  
<!-- <ng-container *ngIf="!creatingNewTemplate"> -->
  <app-project-input *ngIf="showPage && showProjectInput && hasFormAccess" (formDirty)="markDirty()"></app-project-input>
  <div class="additional-inputs-container">
    <div *ngIf="showPage && showProjectInput || (hasChecklistAccess && !hasFormAccess)" class="one-column-content additional-inputs">
      <div
        (mouseenter)="showClearNotes = true"
        (mouseleave)="showClearNotes = false"
        class="flex-container edit-inline-row form-field-container">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{'PROJECT.INITIAL.NOTES' | anessaTranslation: trigger}}</mat-label>
          <textarea
            [(ngModel)]="projectInfo.notes"
            (ngModelChange)="changesMade()"
            [disabled]="projectInfo.isSubmittedProject && isInitialFormUser"
            name="notes"
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="6"
            cdkAutosizeMaxRows="15"></textarea>
        </mat-form-field>
        <p
          *ngIf="projectInfo.notes && showClearNotes && (!isInitialFormUser || !projectInfo.isSubmittedProject)"
          class="form-field-clear"
          (click)="clearInput('notes')">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
      </div>
      <h2 class="center">{{'PROJECT.INITIAL.FILES' | anessaTranslation: trigger}}</h2>
      <div class="member-list relative-container">
        <anessa-table [data]="projectInfo.attachedFiles"
                      [keys]="['name']"
                      [removeTooltipText]="('PROJECT.INITIAL.REMOVE_FILE' | anessaTranslation: trigger)"
                      [cellstyle]="'lr|l'"
                      (onRemove)="onDeleteFile($event)"
                      (onEdit)="onEditFile($event)">
        </anessa-table>
        <div>
          <button class="btn-listadd"
                  *ngIf="(!projectInfo.isSubmittedProject || hasFormAccess) || !isInitialFormUser"
                  type="button"
                  mat-button
                  (click)="onAddFile()">
                  {{'PROJECT.COMMON.ADD_FILE' | anessaTranslation: trigger}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showPage" class="wrapped-button-container fatbuttongroup">
    <button
      mat-button
      *ngIf="!isInitialFormUser"
      class="wrapped-button button-width btn-red"
      type="button"
      (click)="onBack()">
      {{ (showProjectInput) ? ('PROJECT.INITIAL.HIDE_FORM' | anessaTranslation: trigger) : ('PROJECT.COMMON.BACK' | anessaTranslation: trigger) }}
    </button>
    <button
      mat-button
      *ngIf="!showProjectInput && hasFormAccess"
      class="wrapped-button button-width"
      type="button"
      [disabled]="isDisableForm()"
      (click)="onShowForm()">
      {{'PROJECT.INITIAL.FORM' | anessaTranslation: trigger}}
    </button>
    <button
      mat-button
      *ngIf="!showProjectInput && !isInitialFormUser && resultsLoaded"
      class="wrapped-button button-width"
      type="button"
      (click)="onViewResults()">
      {{'PROJECT.INITIAL.RESULTS' | anessaTranslation: trigger}}
    </button>
    <button
      mat-button
      *ngIf="!projectInfo.isSubmittedProject"
      class="wrapped-button button-width"
      type="button"
      [disabled]="!projectInfo.title || disableSaveButtons"
      (click)="onSaveDraft()">
      {{'PROJECT.INITIAL.SAVE_DRAFT' | anessaTranslation: trigger}}
    </button>
    <button
      mat-button
      *ngIf="(showProjectInput && !(projectInfo.isSubmittedProject && !hasFormAccess && isInitialFormUser)) || (projectInfo.isSubmittedProject && hasChecklistAccess && !hasFormAccess && !isInitialFormUser)"
      class="wrapped-button button-width"
      type="button"
      [disabled]="!projectInfo.title || disableSaveButtons"
      (click)="onSubmit()">
      {{ (projectInfo.isSubmittedProject) ? ('PROJECT.COMMON.SAVE' | anessaTranslation: trigger) : ('PROJECT.COMMON.SUBMIT' | anessaTranslation: trigger) }}
    </button>
    <button
      mat-button
      *ngIf="showProjectInput && !isInitialFormUser && projectInfo.isSubmittedProject"
      class="wrapped-button button-width"
      type="button"
      matTooltip="{{'PROJECT.INITIAL.SIMULATE_TOOLTIP' | anessaTranslation: trigger}}"
      [disabled]="!projectInfo.title || disableSaveButtons"
      (click)="onSimulate()">
      {{'PROJECT.INITIAL.SIMULATE' | anessaTranslation: trigger}}
    </button>
    <button
      mat-button
      *ngIf="!showProjectInput && !isInitialFormUser"
      class="wrapped-button button-width btn-green"
      type="button"
      [disabled]="!projectInfo.title || projectInfo.members.length === 0"
      (click)="onSend()">
      {{ projectInfo.isSubmittedProject? ('PROJECT.INITIAL.RESEND_LINK' | anessaTranslation: trigger) : ('PROJECT.INITIAL.SEND_LINK' | anessaTranslation: trigger)}}
    </button>
    <button
      mat-button
      color="warn"
      *ngIf="!showProjectInput && !isInitialFormUser && hasChecklistAccess"
      class="wrapped-button button-width btn-blue"
      type="button"
      (click)="showScopingResults()">
      {{'PROJECT.INITIAL.SCOPING_RESULTS' | anessaTranslation: trigger}}
    </button>
  </div>
<!-- </ng-container> -->
</div>


</form>